function isDebugEnabled(namespace: string): boolean {
  if (typeof window === 'undefined') return false
  const debug = window.localStorage.getItem('debug') ?? ''
  return debug === '*' || debug.includes('dw:*') || debug.includes(namespace)
}

type TimelineNadValue = string | number | boolean | null | object | undefined

export function emitTimelineNadEvent(namespace: string, data: Record<string, TimelineNadValue>): void {
  if (!isDebugEnabled(namespace)) return
  const [, feature, ...concernParts] = namespace.split(':')
  const entry = {
    ts: Date.now(),
    ns: namespace,
    args: [
      {
        feature,
        concern: concernParts.join(':') || undefined,
        ...data,
      },
    ],
  }
  fetch('/api/debug-log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(entry),
    keepalive: true,
  }).catch(() => {})
}
